/*
 * @Author: whb
 * @Date: 2023-01-03 19:30:10
 * @LastEditors: whb
 * @LastEditTime: 2023-01-14 19:54:50
 * @Description: Do not edit
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import star_maker from "../home/img/web_logo.png";
import { tabList } from "./static";
import { Tpl } from "./static2";
import { getParam, debounce } from "../../utils";
// import Select from "react-select";
import { getDoc, getTrans } from "../../api/legal";
import Dialog from "./components/mask";
import SelectRegion from "./components/select-region";
import i18n from "./i18n";
import Shortcuts from "./components/shortcuts";
import { VERSION_TEXT_MAP } from "./libs/constant";
const Doc = (props) => {
  const [current, setCurrent] = useState(0);
  const [display, setPlay] = useState("none");
  const [selLang, setSelLang] = useState("en");
  const [langs, setLangs] = useState({});
  // const [privacyLangsMap, setPrivacyLangMap] = useState({});
  // 隐私
  const [tplContent, setTplContent] = useState("");
  const [h1Info, setH1Info] = useState("");
  const [h2Info, setH2Info] = useState("");
  // 条款
  const [termsTplContent, setTermsTplContent] = useState("");
  const [termsH1Info, setTermsH1Info] = useState("");
  const [termsH2Info, setTermsH2Info] = useState("");
  const [scrollY, setScrollY] = useState(0);
  const [shortcutsPop, setShortcutsPop] = useState("none");
  const [selVersion, setSelVersion] = useState("");
  const navigate = useNavigate();
  const setCur = (index) => {
    setCurrent(index);
    // console.log('index---', privacyLangsMap, `${selLang}_${selVersion}`);
    // 根据大区和语言缓存tpl信息
    // if (index === 0 && privacyLangsMap[`${selLang}_${selVersion}`]) {
    //   return
    // }
    if (index === current) return;
    initData({
      contentType: index,
    });
  };
  const initData = async ({ lang, contentType, region }) => {
    const type = contentType ?? current;
    const paramsLang = lang || selLang;
    const paramsRegion = region || selVersion;
    const res = await getDoc({
      content_type: type === 0 ? "privacy" : "terms",
      app: "sm",
      language: paramsLang,
      region: paramsRegion,
    });
    setSelVersion(res.data.region);
    if (type === 0) {
      setTplContent(res.data.content);
      // setPrivacyLangMap((state) => {
      //   return Object.assign(state, {
      //     [`${res.data.language}_${res.data.region}`]: res.data.content
      //   })
      // });
    } else {
      setTermsTplContent(res.data.content);
    }
  };
  const getTranslate = async (lang) => {
    console.log("selLang--", selLang);
    const res = await getTrans({
      language: lang || selLang,
      words: Object.values(i18n),
    });
    setLangs(res.data);
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleScroll = debounce(() => {
    const scrollYTrans =
      window.scrollY || document.querySelector(".tpl-index").scrollTop;
    setScrollY(scrollYTrans);
  });
  useEffect(() => {
    const type = getParam("type") * 1 || 0;
    console.log("getParam", type);
    const paramsLang = getParam("lang") || "en";
    const region = getParam("region") || "";
    setSelLang(paramsLang);
    setSelLang((state) => {
      getTranslate(state);
      initData({
        lang: state,
        region,
        contentType: type,
      });
      return state;
    });
    if (type) {
      setCurrent(parseInt(type));
    }
    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getH1h2 = (type) => {
    const contentMain = document.querySelector(".content-main");
    const pageH1 = contentMain?.getElementsByTagName("h1")[0];
    if (type === 0) {
      setH1Info(pageH1?.innerHTML);
      setH2Info(Array.from(contentMain.getElementsByTagName("h2")));
      setH2Info((state) => {
        state = state.map((item, index) => {
          // const uuid = getUUID();
          item.classList.add("st-privacy-" + index);
          return {
            key: "st-privacy-" + index,
            value: `<h2>${item.innerHTML}</h2>`,
          };
        });
        return state;
      });
    } else {
      setTermsH1Info(pageH1?.innerHTML);
      setTermsH2Info(Array.from(contentMain.getElementsByTagName("h2")));
      setTermsH2Info((state) => {
        state = state.map((item, index) => {
          // const uuid = getUUID();
          item.classList.add("st-terms-" + index);
          return {
            key: "st-terms-" + index,
            value: `<h2>${item.innerHTML}</h2>`,
          };
        });
        return state;
      });
    }
    if (pageH1) {
      if (type === 0) {
        setH1Info((state) => {
          state = state.replaceAll("font-size:", "");
          return state;
        });
      } else {
        setTermsH1Info((state) => {
          state = state.replaceAll("font-size:", "");
          return state;
        });
      }
      pageH1.style.display = "none";
    }
  };
  useEffect(() => {
    getH1h2(0);
  }, [tplContent, current]);
  useEffect(() => {
    getH1h2(1);
  }, [termsTplContent, current]);

  const renderItem = () => {
    if (current === 0) {
      return (
        <Tpl
          langs={langs}
          region={selVersion}
          content={tplContent}
          h1Info={h1Info}
        />
      );
    } else {
      return (
        <Tpl
          langs={langs}
          region={selVersion}
          content={termsTplContent}
          h1Info={termsH1Info}
        />
      );
    }
  };
  // const setOption = (e) => {
  //   console.log("value", e);
  //   setSelectedOption(e.value);
  // };
  const hideShortcutsPop = () => {
    setShortcutsPop("none");
  };
  const hideDisplay = () => {
    setPlay("none");
  };
  const selCb = async ({ version, lang, init }) => {
    setSelVersion(version);
    setSelLang(lang);
    // const prefix = window.location.hash.includes('?') ? '&' : '?';
    const params = `?type=${current}&region=${version}&lang=${lang}`;
    console.log("jump path--", init, params);
    if (!init) {
      navigate(`/doc${params}`, {
        replace: true,
      });
      getTranslate(lang);
      // // 清空tpl内容
      // setTplContent('');
      // setTermsTplContent('');
      initData({
        lang,
        region: version,
      });
    }
  };
  return (
    <div className={["doc-page", "doc-tpl", selLang].join(" ")}>
      <div className="h-24 doc-title px-44">
        <img className="pt-4" src={star_maker} alt="" />
      </div>
      <div className="border-b-2 border-indigo-600 doc-tab px-44">
        {tabList &&
          tabList.map((item, index) => (
            <div
              className={`doc-tab-item-space h-10 cursor-pointer ${
                current === index ? "active" : ""
              }`}
              onClick={() => setCur(index)}
              key={item.text}
            >
              <span>{langs[item.text]}</span>
              {index === 0 && <div className="doc-tab-line-space"></div>}
            </div>
          ))}
      </div>
      <div className="pt-5 pb-1 select-new px-44">
        {/* <div className='select-cont '>
          <Select
            defaultValue={selectedOption}
            onChange={setOption}
            options={options}
          />
        </div> */}
        <div className="select-entry" onClick={() => setPlay(true)}>
          <span>{langs[VERSION_TEXT_MAP[selVersion]]}</span>
        </div>
        <div className="menu" onClick={() => setShortcutsPop(true)}></div>
      </div>
      <div className="pt-5 pb-8 doc-content px-44">
        {/* {current === 0 ? <Other1 /> : <Other2 />} */}
        {renderItem()}
      </div>
      <Dialog display={display} hide={hideDisplay}>
        <SelectRegion
          lang={selLang}
          langs={langs}
          hide={hideDisplay}
          defaultVersion={selVersion}
          sel={selCb}
          display={display}
        />
      </Dialog>
      <Dialog
        display={shortcutsPop}
        hide={hideShortcutsPop}
        class="shortcutsPop"
      >
        <Shortcuts
          list={current === 0 ? h2Info : termsH2Info}
          current={current}
          hide={hideShortcutsPop}
          langs={langs}
        ></Shortcuts>
      </Dialog>
      {scrollY > 100 ? <div className="scroll-top" onClick={toTop}></div> : ""}
    </div>
  );
};

export default Doc;
